import { useIntl, defineMessages } from 'react-intl'

import { Select } from 'components/v2/Select'
import { TYPE } from 'features/Inventories/components/Type/constants'
import { typeMessages } from 'features/Inventories/components/Type/messages'

const TYPES_LIST = [TYPE.BASE, TYPE.WAREHOUSE]

const messages = defineMessages({
  selectType: {
    id: 'spanish.inventories.type.placeholder',
    defaultMessage: 'Seleccionar tipo de almacén'
  }
})

export const SelectType = (props: TSFixMe): TSFixMe => {
  const intl = useIntl()

  return (
    <Select {...props}>
      <option value="">{intl.formatMessage(messages.selectType)}</option>

      {TYPES_LIST.map((type): TSFixMe => {
        return (
          <option value={type} key={type}>
            {intl.formatMessage(typeMessages[type])}
          </option>
        )
      })}
    </Select>
  )
}
